import { useState,useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Upload, Plus, X, Clock, Users, ChefHat, Image as ImageIcon,
  Flame, Beef, Wheat, Droplets, Star, Trash2
} from "lucide-react";
import { Header } from "../components/Header";
import axios from "axios";
import { addRecipeApi, getCategoriesApi, loginApi } from "../http/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslate } from "../components/UseTranslate";

const styles = {
  container: {
    minHeight: "100vh",
    background: "#060606",
    backgroundImage: `url("https://png.pngtree.com/thumb_back/fw800/background/20250228/pngtree-premium-high-quality-fast-food-background-for-projects-image_17023184.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    padding: "3rem 0 4rem",
    position: "relative",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.88)",
    pointerEvents: "none",
    zIndex: 0,
  },
  wrapper: {
    maxWidth: 860,
    margin: "0 auto",
    padding: "0 1.25rem",
    position: "relative",
    zIndex: 1,
  },
  pageHeader: {
    marginBottom: "2.5rem",
  },
  tag: {
    display: "inline-block",
    background: "rgba(234,88,12,0.18)",
    color: "#fb923c",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    padding: "4px 12px",
    borderRadius: 999,
    marginBottom: 14,
    border: "1px solid rgba(234,88,12,0.3)",
  },
  title: {
    fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
    fontWeight: 800,
    color: "#fff",
    marginBottom: 8,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  subtitle: {
    color: "#9ca3af",
    fontSize: 15,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    border: "1px solid rgba(255,255,255,0.09)",
    padding: "1.75rem",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  cardTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#fb923c",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    marginBottom: 4,
  },
  uploadBox: {
    border: "2px dashed rgba(234,88,12,0.4)",
    borderRadius: 12,
    padding: "2.5rem 1rem",
    textAlign: "center",
    cursor: "pointer",
    transition: "border-color 0.2s, background 0.2s",
    background: "rgba(234,88,12,0.04)",
    display: "block",
  },
  uploadContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    color: "#6b7280",
  },
  uploadIcon: { color: "#ea580c" },
  uploadText: { color: "#9ca3af", fontSize: 14 },
  uploadSub: { color: "#6b7280", fontSize: 12, marginTop: 2 },
  previewImage: {
    width: "100%",
    height: 260,
    objectFit: "cover",
    borderRadius: 10,
  },
  hiddenInput: { display: "none" },
  input: {
    padding: "11px 14px",
    borderRadius: 9,
    border: "1px solid rgba(255,255,255,0.12)",
    fontSize: 14,
    background: "rgba(255,255,255,0.06)",
    color: "#f3f4f6",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  textarea: {
    padding: "11px 14px",
    borderRadius: 9,
    border: "1px solid rgba(255,255,255,0.12)",
    fontSize: 14,
    background: "rgba(255,255,255,0.06)",
    color: "#f3f4f6",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    resize: "vertical",
    minHeight: 100,
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  },
  select: {
    padding: "11px 14px",
    borderRadius: 9,
    border: "1px solid rgba(255,255,255,0.12)",
    fontSize: 14,
    background: "#1a1a1a",
    color: "#f3f4f6",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    cursor: "pointer",
    appearance: "none",
    WebkitAppearance: "none",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1rem",
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "1rem",
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gap: "1rem",
  },
  label: {
    fontSize: 12,
    color: "#9ca3af",
    fontWeight: 600,
    marginBottom: 5,
    display: "flex",
    alignItems: "center",
    gap: 5,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
  },
  listRow: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
  },
  listNumber: {
    width: 28,
    height: 28,
    minWidth: 28,
    borderRadius: "50%",
    background: "rgba(234,88,12,0.15)",
    color: "#fb923c",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    marginTop: 10,
    border: "1px solid rgba(234,88,12,0.25)",
  },
  removeBtn: {
    background: "rgba(239,68,68,0.12)",
    border: "1px solid rgba(239,68,68,0.2)",
    color: "#f87171",
    borderRadius: 8,
    padding: "0 10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    marginTop: 8,
    transition: "background 0.2s",
    minWidth: 40,
  },
  addBtn: {
    background: "rgba(234,88,12,0.1)",
    border: "1px dashed rgba(234,88,12,0.35)",
    color: "#fb923c",
    borderRadius: 9,
    padding: "10px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    fontWeight: 600,
    transition: "background 0.2s",
    width: "100%",
    justifyContent: "center",
  },
  ingredientGrid: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr auto",
    gap: 8,
    alignItems: "flex-start",
  },
  nutritionGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gap: "1rem",
  },
  nutritionCard: {
    background: "rgba(234,88,12,0.07)",
    border: "1px solid rgba(234,88,12,0.15)",
    borderRadius: 10,
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  nutritionIcon: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: "#fb923c",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  toggleRow: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  toggleBtn: (active) => ({
    padding: "8px 16px",
    borderRadius: 999,
    border: active ? "1px solid #ea580c" : "1px solid rgba(255,255,255,0.12)",
    background: active ? "rgba(234,88,12,0.2)" : "rgba(255,255,255,0.04)",
    color: active ? "#fb923c" : "#9ca3af",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s",
  }),
  submitBtn: {
    background: "linear-gradient(135deg, #ea580c, #c2410c)",
    color: "white",
    padding: "15px",
    border: "none",
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 15,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    boxShadow: "0 4px 24px rgba(234,88,12,0.35)",
    transition: "opacity 0.2s, transform 0.1s",
    letterSpacing: "0.02em",
  },
  divider: {
    height: 1,
    background: "rgba(255,255,255,0.07)",
    margin: "0.25rem 0",
  },
  featuredRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 14px",
    background: "rgba(234,88,12,0.06)",
    border: "1px solid rgba(234,88,12,0.15)",
    borderRadius: 10,
  },
  featuredLabel: { color: "#e5e7eb", fontSize: 14, fontWeight: 500 },
  featuredSub: { color: "#6b7280", fontSize: 12, marginTop: 2 },
  toggle: (active) => ({
    width: 46,
    height: 26,
    borderRadius: 999,
    background: active ? "#ea580c" : "rgba(255,255,255,0.12)",
    border: "none",
    cursor: "pointer",
    position: "relative",
    transition: "background 0.2s",
    padding: 0,
  }),
  toggleThumb: (active) => ({
    position: "absolute",
    top: 3,
    left: active ? 23 : 3,
    width: 20,
    height: 20,
    borderRadius: "50%",
    background: "#fff",
    transition: "left 0.2s",
    boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  }),
};

const DIFFICULTIES = ["Easy", "Medium", "Hard"];
const MEAL_TYPES = ["Breakfast", "Lunch", "Dinner", "Snack", "Dessert"];
const DIET_TYPES = ["Veg", "Non Veg", "Vegan", "Keto", "Low Carb", "High Protein"];

export default function AddRecipePage() {
  const [formData, setFormData] = useState({
    recipe_name: "",
    description: "",
    category_id: "",
    prep_time: "",
    cook_time: "",
    servings: "",
    difficulty: "Easy",
    meal_type: "Dinner",
    diet_type: "Non Veg",
    calories: "",
    protein: "",
    carbs: "",
    fats: "",
    video_url: "",
    featured: false,
    status: "active",
  });

  const [categories,setCategories] = useState([]);

  const {language} = useSelector((state)=>state.language)

  const user = localStorage.getItem('user')


  const LoginUser=()=>{
    const alias = localStorage.getItem('alias');
    const name = 'Food Box User'

    try{
      const result = axios.post(loginApi,{name:name})
      console.log(result);
      localStorage.setItem('user',result?.data?.user)
    }
    catch(err){
      console.log(err,'errr========')
    }
  }

  useEffect(()=>{
    if(!user){
      LoginUser()
    }
    
  },[])


  const navigate = useNavigate()

  const [ingredients, setIngredients] = useState([
    { ingredient: "", quantity: "" },
  ]);
  const [steps, setSteps] = useState([""]);
  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggle = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

 const handleImageUpload = (e) => {
  const file = e.target.files?.[0];

  if (!file) return;

  // Save actual file
  setFormData((prev) => ({
    ...prev,
    image: file,
  }));

  // Preview
  const reader = new FileReader();

  reader.onloadend = () => {
    setImagePreview(reader.result);
  };

  reader.readAsDataURL(file);
};

  // Ingredients
  const addIngredient = () =>
    setIngredients((prev) => [...prev, { ingredient: "", quantity: "" }]);
  const removeIngredient = (i) =>
    setIngredients((prev) => prev.filter((_, idx) => idx !== i));
  const updateIngredient = (i, field, val) =>
    setIngredients((prev) =>
      prev.map((item, idx) => (idx === i ? { ...item, [field]: val } : item))
    );

  // Steps
  const addStep = () => setSteps((prev) => [...prev, ""]);
  const removeStep = (i) =>
    setSteps((prev) => prev.filter((_, idx) => idx !== i));
  const updateStep = (i, val) =>
    setSteps((prev) => prev.map((s, idx) => (idx === i ? val : s)));



    const fetchCategories=async()=> {
    // setLoading(true);
    try{
      const response = await axios.get(getCategoriesApi(language));
      console.log(response.data,"categories");
      setCategories(response?.data?.categories);
    }
    catch(err){
      console.log(err);
    }
  }


  useEffect(()=>{
    fetchCategories();
  },[language])


  console.log(formData.image);



 
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const payload = new FormData();

    payload.append("recipe_name", formData.recipe_name);
    payload.append("category_id", formData.category_id);
    payload.append("description", formData.description);
    payload.append("servings", formData.servings);
    payload.append("prep_time", formData.prep_time);
    payload.append("cook_time", formData.cook_time);
    payload.append("calories", formData.calories);
    payload.append("protein", formData.protein);
    payload.append("carbs", formData.carbs);
    payload.append("fats", formData.fats);
    payload.append("difficulty", formData.difficulty);
    payload.append("meal_type", formData.meal_type);
    payload.append("diet_type", formData.diet_type);
    payload.append("video_url", formData.video_url);
    payload.append("featured", formData.featured);
    payload.append("status", formData.status);

    // Image
    if (formData.image) {
      payload.append("image", formData.image);
    }

    // Ingredients
    payload.append(
      "ingredients",
      JSON.stringify(
        ingredients.filter((item) => item.ingredient.trim())
      )
    );

    // Steps
    payload.append(
      "steps",
      JSON.stringify(
        steps
          .filter((step) => step.trim())
          .map((instruction, index) => ({
            step_number: index + 1,
            instruction,
          }))
      )
    );

    const response = await axios.post(
      addRecipeApi, // Replace with your actual endpoint
      payload
    );

    toast.success(response.data.msg);
    navigate('/')

  } catch (err) {
    console.error(err);

    toast.error(
      err.response?.data?.msg ||
      "Something went wrong!"
    );
  }
};

const {t} = useTranslate()


  const totalTime =
    (parseInt(formData.prep_time) || 0) + (parseInt(formData.cook_time) || 0);

  return (
    <><Header/>
    <div style={styles.container}>
      
      <div style={styles.overlay} />
      <div style={styles.wrapper}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          {/* Header */}
          <div style={styles.pageHeader}>
            <div style={styles.tag}>{t('New Recipe')}</div>
            <h1 style={styles.title}>{t('Share Your Recipe')}</h1>
            <p style={styles.subtitle}>
              {t('Fill in the details below to publish your recipe to the community')}
            </p>
          </div>

          <form onSubmit={handleSubmit} style={styles.form}>

            {/* ── IMAGE ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>{t('Recipe Photo')}</div>
              <label style={styles.uploadBox}>
                {imagePreview ? (
                  <img src={imagePreview} alt="Preview" style={styles.previewImage} />
                ) : (
                  <div style={styles.uploadContent}>
                    <ImageIcon size={42} style={styles.uploadIcon} />
                    <span style={styles.uploadText}>{t('Click to upload a photo')}</span>
                    <span style={styles.uploadSub}>JPG, PNG, WEBP up to 10MB</span>
                  </div>
                )}
                <input
                  type="file"
                  style={styles.hiddenInput}
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </label>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Video URL (optional)')}</label>
                <input
                  name="video_url"
                  type="url"
                  placeholder="https://youtube.com/..."
                  value={formData.video_url}
                  onChange={handleChange}
                  style={styles.input}
                />
              </div>
            </div>

            {/* ── BASIC INFO ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>{t('Basic Info')}</div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Recipe Name')} *</label>
                <input
                  name="recipe_name"
                  type="text"
                  placeholder="e.g. Creamy Tuscan Chicken"
                  value={formData.recipe_name}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Description')} *</label>
                <textarea
                  name="description"
                  placeholder="Tell us what makes this recipe special..."
                  value={formData.description}
                  onChange={handleChange}
                  style={styles.textarea}
                  required
                />
              </div>

              {/* <div style={styles.fieldGroup}>
                <label style={styles.label}>Category ID</label>
                <input
                  name="category_id"
                  type="number"
                  placeholder="e.g. 2"
                  value={formData.category_id}
                  onChange={handleChange}
                  style={styles.input}
                />
              </div> */}




<div style={styles.fieldGroup}>
  <label style={styles.label}>{t('Category')}</label>

  <select
    name="category_id"
    value={formData.category_id}
    onChange={handleChange}
    style={styles.select}
    required
  >
    <option value="">{t('Select Category')}</option>

    {categories.map((category) => (
      <option key={category.id} value={category.id}>
        {category.category_name}
      </option>
    ))}
  </select>
</div>








            </div>

            {/* ── TIME & SERVINGS ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>
                <Clock size={13} style={{ display: "inline", marginRight: 5 }} />
                {t('Time & Servings')}
              </div>

              <div style={styles.grid3}>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>
                    <Clock size={11} /> {t('Prep Time (min)')}
                  </label>
                  <input
                    name="prep_time"
                    type="number"
                    min="0"
                    placeholder="15"
                    value={formData.prep_time}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>
                    <Flame size={11} /> {t('Cook Time (min)')}
                  </label>
                  <input
                    name="cook_time"
                    type="number"
                    min="0"
                    placeholder="30"
                    value={formData.cook_time}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>
                    <Users size={11} /> {t('Servings')}
                  </label>
                  <input
                    name="servings"
                    type="number"
                    min="1"
                    placeholder="4"
                    value={formData.servings}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
              </div>

              {totalTime > 0 && (
                <div style={{ color: "#fb923c", fontSize: 13, fontWeight: 600 }}>
                  ⏱ Total time: {totalTime} minutes
                </div>
              )}
            </div>

            {/* ── CLASSIFICATION ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>
                <ChefHat size={13} style={{ display: "inline", marginRight: 5 }} />
                {t('Classification')}
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Difficulty')}</label>
                <div style={styles.toggleRow}>
                  {DIFFICULTIES.map((d) => (
                    <button
                      key={d}
                      type="button"
                      style={styles.toggleBtn(formData.difficulty === d)}
                      onClick={() => handleToggle("difficulty", d)}
                    >
                      {d}
                    </button>
                  ))}
                </div>
              </div>

              <div style={styles.divider} />

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Meal Type')}</label>
                <div style={styles.toggleRow}>
                  {MEAL_TYPES.map((m) => (
                    <button
                      key={m}
                      type="button"
                      style={styles.toggleBtn(formData.meal_type === m)}
                      onClick={() => handleToggle("meal_type", m)}
                    >
                      {m}
                    </button>
                  ))}
                </div>
              </div>

              <div style={styles.divider} />

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Diet Type')}</label>
                <div style={styles.toggleRow}>
                  {DIET_TYPES.map((d) => (
                    <button
                      key={d}
                      type="button"
                      style={styles.toggleBtn(formData.diet_type === d)}
                      onClick={() => handleToggle("diet_type", d)}
                    >
                      {d}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* ── NUTRITION ── */}
            {/* <div style={styles.card}>
              <div style={styles.cardTitle}>Nutrition (per serving)</div>
              <div style={styles.nutritionGrid}>
                {[
                  { key: "calories", label: "Calories", icon: <Flame size={12} />, unit: "kcal", type: "number" },
                  { key: "protein", label: "Protein", icon: <Beef size={12} />, unit: "g", type: "number" },
                  { key: "carbs", label: "Carbs", icon: <Wheat size={12} />, unit: "g", type: "number" },
                  { key: "fats", label: "Fats", icon: <Droplets size={12} />, unit: "g", type: "number" },
                ].map(({ key, label, icon, unit, type }) => (
                  <div key={key} style={styles.nutritionCard}>
                    <div style={styles.nutritionIcon}>
                      {icon} {label}
                    </div>
                    <input
                      name={key}
                      type={type}
                      min="0"
                      step="0.01"
                      placeholder="0"
                      value={formData[key]}
                      onChange={handleChange}
                      style={{ ...styles.input, padding: "8px 10px", fontSize: 13 }}
                    />
                    <span style={{ color: "#6b7280", fontSize: 11 }}>{unit}</span>
                  </div>
                ))}
              </div>
            </div> */}

            {/* ── INGREDIENTS ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>{t('Ingredients')}</div>

              <AnimatePresence>
                {ingredients.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    transition={{ duration: 0.18 }}
                  >
                    <div style={styles.listRow}>
                      <div style={styles.listNumber}>{i + 1}</div>
                      <div style={{ flex: 1, display: "grid", gridTemplateColumns: "2fr 1fr", gap: 8 }}>
                        <div style={styles.fieldGroup}>
                          {i === 0 && <label style={styles.label}>{t('Ingredient')}</label>}
                          <input
                            type="text"
                            placeholder={t('e.g. chicken breast')}
                            value={item.ingredient}
                            onChange={(e) => updateIngredient(i, "ingredient", e.target.value)}
                            style={styles.input}
                          />
                        </div>
                        <div style={styles.fieldGroup}>
                          {i === 0 && <label style={styles.label}>{t('Quantity')}</label>}
                          <input
                            type="text"
                            placeholder={t('e.g. 2 cups')}
                            value={item.quantity}
                            onChange={(e) => updateIngredient(i, "quantity", e.target.value)}
                            style={styles.input}
                          />
                        </div>
                      </div>
                      {ingredients.length > 1 && (
                        <button
                          type="button"
                          style={{ ...styles.removeBtn, marginTop: i === 0 ? 26 : 8 }}
                          onClick={() => removeIngredient(i)}
                        >
                          <X size={15} />
                        </button>
                      )}
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>

              <button type="button" style={styles.addBtn} onClick={addIngredient}>
                <Plus size={15} /> {t('Add Ingredient')}
              </button>
            </div>

            {/* ── STEPS ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>{t('Preparation Steps')}</div>

              <AnimatePresence>
                {steps.map((step, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    transition={{ duration: 0.18 }}
                  >
                    <div style={styles.listRow}>
                      <div style={styles.listNumber}>{i + 1}</div>
                      <textarea
                        placeholder={`${t('Step')} ${i + 1}: ${t('describe what to do')}...`}
                        value={step}
                        onChange={(e) => updateStep(i, e.target.value)}
                        style={{ ...styles.textarea, flex: 1, minHeight: 72 }}
                      />
                      {steps.length > 1 && (
                        <button
                          type="button"
                          style={styles.removeBtn}
                          onClick={() => removeStep(i)}
                        >
                          <X size={15} />
                        </button>
                      )}
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>

              <button type="button" style={styles.addBtn} onClick={addStep}>
                <Plus size={15} /> {t('Add Step')}
              </button>
            </div>

            {/* ── PUBLISHING OPTIONS ── */}
            <div style={styles.card}>
              <div style={styles.cardTitle}>{t('Publishing')}</div>

              <div style={styles.featuredRow}>
                <div>
                  <div style={styles.featuredLabel}>
                    <Star size={13} style={{ display: "inline", marginRight: 5, color: "#fb923c" }} />
                    {t('Feature this recipe')}
                  </div>
                  <div style={styles.featuredSub}>{t('Featured recipes appear on the homepage')}</div>
                </div>
                <button
                  type="button"
                  style={styles.toggle(formData.featured)}
                  onClick={() => handleToggle("featured", !formData.featured)}
                >
                  <div style={styles.toggleThumb(formData.featured)} />
                </button>
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label}>{t('Status')}</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  style={styles.select}
                >
                  <option value="active">{t('Active — visible to everyone')}</option>
                  <option value="inactive">{t('Inactive — hidden from listing')}</option>
                </select>
              </div>
            </div>

            {/* ── SUBMIT ── */}
            <motion.button
              type="submit"
              style={styles.submitBtn}
              whileHover={{ opacity: 0.9 }}
              whileTap={{ scale: 0.98 }}
            >
              <Upload size={18} />
              {t('Publish Recipe')}
            </motion.button>

          </form>
        </motion.div>
      </div>
    </div>
    </>
  );
}